import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';

import CreateEditForm from './CreateEditForm';
import FollowUpForm from './FollowUpForm';
import { formatPath } from '../../../utils/textFormaters';
import routes from '../../routes/path';
import { psmAuditDigital } from '../../../actionTypes';

const AuditForm = () => {
  const { id, auditId } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const pendingCompanyRedirect = useSelector(state => state.psmAuditDigital.pendingCompanyRedirect);
  const isNew = !auditId || auditId === 'new';
  const isFollowUp = history.location.pathname.endsWith('/follow-up');
  const handleBack = () => history.goBack();

  useEffect(() => {
    if (!pendingCompanyRedirect) return;
    dispatch(push(formatPath(routes.private.company.id, { id: pendingCompanyRedirect })));
    dispatch({ type: psmAuditDigital.pendingCompanyRedirectClear });
  }, [pendingCompanyRedirect, dispatch]);

  if (isFollowUp) {
    return <FollowUpForm id={id} auditId={auditId} onBack={handleBack} />;
  }

  return <CreateEditForm id={id} auditId={auditId} isNew={isNew} onBack={handleBack} />;
};

export default AuditForm;
